import * as React from 'react';
import { connect } from "react-redux";
import { NavLink, withRouter } from 'react-router-dom';
import AuthService from "../../../classes/auth.service";
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from "../../../classes/http/HttpRequests";
import AppRoutes from '../../../config/appRoutes';
import headerReduxProps from "../../Header/HeaderReduxProps";
import './NavigationItem.css';
var NavigationItem = function (props) {
    var api = new ApiRequests();
    var http = new HttpRequests();
    var messages = null;
    var logOut = function (link) {
        hideSidebar();
        api.logout(AuthService.getToken())
            .then(function (response) {
            AuthService.userLogout(props.history);
        })
            .catch(function (error) {
            http.handleError(error, messages, 'Проблем с отписването. Моля, опитайте отново', props.history);
            console.error('error', error);
        });
    };
    var hideSidebar = function () {
        if (window.innerWidth <= 992) {
            props.onHideSidebar();
        }
    };
    var showEditUserModal = function () {
        props.onShowSelfEditUserModal();
        props.onHideSidebar();
    };
    var showEditUserPassModal = function () {
        props.onShowSelfEditPassModal();
        props.onHideSidebar();
    };
    var element = React.createElement(NavLink, { exact: props.exact, className: "nav-link", to: "" + (props.relative ? props.match.url : '') + props.link, onClick: hideSidebar },
        React.createElement("i", { className: 'nav-icon ' + props.icon }),
        "\u00A0",
        props.children);
    switch (props.link) {
        case AppRoutes.login.path:
            element = React.createElement("a", { className: "nav-link", onClick: function () { return logOut(props.link); } },
                React.createElement("i", { className: 'nav-icon ' + props.icon }),
                "\u00A0",
                props.children);
            break;
        case 'editUser':
            element = React.createElement("a", { className: "nav-link edit-user-mobile", onClick: function () { return showEditUserModal(); } },
                React.createElement("i", { className: 'nav-icon ' + props.icon }),
                "\u00A0",
                props.children);
            break;
        case 'changeUserPass':
            element = React.createElement("a", { className: "nav-link edit-user-mobile", onClick: function () { return showEditUserPassModal(); } },
                React.createElement("i", { className: 'nav-icon ' + props.icon }),
                "\u00A0",
                props.children);
            break;
    }
    return (React.createElement("li", { className: "nav-item", id: props.id }, element));
};
// @ts-ignore
export default withRouter(connect(headerReduxProps.mapStateToProps, headerReduxProps.mapDispatchToProps)(NavigationItem));



//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/NavigationItem/NavigationItem.tsx
// module id = 100
// module chunks = 0